export const slackLoginPopup = (clientId, redirectURI, userScope) => {
    return new Promise((resolve, reject) => {
        const slackOAuthURL = `https://slack.com/oauth/v2/authorize?client_id=${clientId}&user_scope=${userScope}&redirect_uri=${redirectURI}&team=T9RRYVC8Y`;

        const popup = window.open(slackOAuthURL, 'SlackLogin', 'width=500,height=600');

        if (!popup) {
            reject('Popup blocked! Allow popups in your browser.');
            return;
        }
        
        const start = Date.now()
        let success = false

        const checkPopup = setInterval(() => {
            if ( success == true || Date.now() - start > 30000 )
                clearInterval(checkPopup)
            try {
                const url = popup.location.href;
                if (url.includes('code=')) {
                    const urlParams = new URLSearchParams(popup.location.search);
                    const authCode = urlParams.get('code');
                    popup.close();
                    clearInterval(checkPopup);
                    resolve(authCode);
                    success = true
                }
            } catch (error) {
                console.log(error)
            }
        }, 500);
    });
};
